(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('CloudPBXPrefixSearch', CloudPBXPrefixSearch);

    CloudPBXPrefixSearch.$inject = ['$resource'];

    function CloudPBXPrefixSearch($resource) {
        var resourceUrl =  'api/_search/cloud-pbx-prefixes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
